import { CheckCircle2, Lock, Unlock, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { CommercialCycle } from "@/lib/api";

interface CycleActionButtonsProps {
  cycle: CommercialCycle;
  onPublish: (year: number) => void;
  onOpen: (year: number) => void;
  onStartClosing: (year: number) => void;
  onClose: (year: number) => void;
  isPublishing: boolean;
  isOpening: boolean;
  isStartingClosing: boolean;
  isClosing: boolean;
}

export function CycleActionButtons({
  cycle,
  onPublish,
  onOpen,
  onStartClosing,
  onClose,
  isPublishing,
  isOpening,
  isStartingClosing,
  isClosing,
}: CycleActionButtonsProps) {
  switch (cycle.status) {
    case "Draft":
      return (
        <Button
          size="sm"
          onClick={() => onPublish(cycle.year)}
          disabled={isPublishing}
        >
          <CheckCircle2 className="h-4 w-4 mr-1" /> Publicar
        </Button>
      );
    case "Published":
      return (
        <Button
          size="sm"
          onClick={() => onOpen(cycle.year)}
          disabled={isOpening}
        >
          <Unlock className="h-4 w-4 mr-1" /> Abrir
        </Button>
      );
    case "Open":
      return (
        <Button
          size="sm"
          variant="outline"
          onClick={() => onStartClosing(cycle.year)}
          disabled={isStartingClosing}
        >
          <Clock className="h-4 w-4 mr-1" /> Iniciar fechamento
        </Button>
      );
    case "Closing":
      return (
        <Button
          size="sm"
          variant="outline"
          onClick={() => onClose(cycle.year)}
          disabled={isClosing}
        >
          <Lock className="h-4 w-4 mr-1" /> Fechar
        </Button>
      );
    default:
      return null;
  }
}
